<template>
  <a-modal
    :title="language['common.importExcel']"
    :width="width"
    :visible="visible"
    switchFullscreen
    :confirmLoading="uploading"
    @cancel="handleClose">
    <div style="margin: 0px 0px 5px 1px" v-if="online">
      <span style="display: inline-block;height: 32px;line-height: 32px;vertical-align: middle;">{{language['common.openValidOrNot']}}<!--是否开启校验-->:</span>
      <span style="display: inline-block;height: 32px;margin-left: 6px">
         <a-switch :checked="validateStatus==1" @change="handleChangeValidateStatus" checked-children="是" un-checked-children="否" size="small"/>
      </span>
    </div>     
    <div>通过此功能导入Excel文件，您可以实现活動與場館"{{operation.titleSetSeat}}"的人員信息的批量選座操作；请您在导入之前，下载最新的Excel模板<a-button type="primary" icon="download" @click="ExportTemplateXls" style="left:20px">{{language['system.downloadTemplate']}}</a-button>
          </div>
 

    <a-upload
      name="file"
      accept=".xls,.xlsx"
      :multiple="false"
      :fileList="fileList"
      :remove="handleRemove"
      :beforeUpload="beforeUpload">
      <a-button>
        <a-icon type="upload" />
        {{language['common.chooseImportFile']}}<!--选择导入文件-->
      </a-button>
    </a-upload>
<div v-show="isShowErrorData">
  <div>{{errorMsg}} <a-button type="primary" icon="download" @click="handleExportErrData" style="left:20px">导出错误数据</a-button></div>
  <div> <a-table :dataSource="dataSource" :columns="columns"
  size="middle"
          bordered
          rowKey="sysid"
          class="j-table-force-nowrap"
          :scroll="{x:1800}"
  />

</div>
</div>
    <template slot="footer">
      <a-button @click="handleClose">{{language['common.closeButton']}}<!--关闭--></a-button>
      <a-button
        type="primary"
        @click="handleImport"
        :disabled="fileList.length != 1"
        :loading="uploading">
        {{ uploading ? language['common.uploading']+'...' : language['common.startUpload'] }}<!--{{ uploading ? '上传中...' : '开始上传' }}-->
      </a-button>
    </template>

  </a-modal>
</template>

<script>
  import { postAction,downFile,downloadFile } from '@/api/manageChooseSeat'
    import '@/assets/less/TableExpand.less'
    import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'
    import { exportFileExcel } from '@/api/exportFile'
  export default {
    name: 'JImportModal',
    inject:['operation'],
    props:{
      url:{
        type: String,
        default: '',
        required: false
      },
      biz:{
        type: String,
        default: '',
        required: false
      },
      //是否online导入
      online:{
        type: Boolean,
        default: false,
        required: false
      }
    },
    data(){
      return {
        visible:false,
        uploading:false,
        fileList:[],
        uploadAction:'',
        foreignKeys:'',
        width:1200,
        validateStatus: 0,
        isShowErrorData:false,
        errorMsg:'',
        dataSource:[]
      }
    },
    watch: {
      url (val) {
        if(val){
         this.uploadAction = window._CONFIG['chooseSeatDomainURL']+val
        }
      }
    },
    created () {
      this.uploadAction = window._CONFIG['chooseSeatDomainURL']+this.url
   
    },
    computed: {
      language() {
        return this.$store.getters.language;
      },
        columns() {
          if (this.language) {
            return  [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title: this.language['cs.person.personid'],
              align:"left",
              width:150,
              dataIndex: 'personid'
            },
            {
              title:this.language['cs.person.pname'],
              align:"left",
              width:150,
              dataIndex: 'pname'
            },
            {
              title:this.language['cs.person.sex'],
              align:"left",
              width:150,
              dataIndex: 'sex'
            },
            {
              title:this.language['cs.person.jobname'],
              align:"left",
              width:150,
              dataIndex: 'jobname'
            }, 
            {
              title:this.language['cs.person.deptname'],
              align:"left",
              width:150,
              dataIndex: 'deptname'
            }, 
             {
              title:this.language['cs.person.phone'],
              align:"left",
              width:150,
              dataIndex: 'phone'
            }, 
            {
              title:this.language['cs.person.email'],
              align:"left",
              width:150,
              dataIndex: 'email'
            }, 
            {
              title:this.language['cs.person.workno'],
              align:"left",
              width:150,
              dataIndex: 'workno'
            }, 
            {
              title:"座位編號",
              align:"left",
              width:150,
              dataIndex: 'seatno'
            }, 
             
            
            {
              title:"错误信息",
              align:"left",
              width:150,
              dataIndex: 'errormsg',
              ellipsis: true,
            }, 
      
           
          ]
          }
        }
    },
    methods:{
      handleClose(){
        this.visible=false
     
      },
      show(arg){
        this.fileList = []
        this.uploading = false
        this.visible = true
        this.foreignKeys = arg;
        this.validateStatus = 0
        this.errorMsg="";
        this.isShowErrorData=false;
         this.dataSource=[];
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList
      },
      beforeUpload(file) {
        this.fileList = [...this.fileList, file]
        return false;
      },
      handleImport() {
        const { fileList } = this;
        const formData = new FormData();
        if(this.biz){
          formData.append('isSingleTableImport',this.biz);
        }
        if(this.foreignKeys && this.foreignKeys.length>0){
          formData.append('foreignKeys',this.foreignKeys);
        }
        if(this.online==true){
          formData.append('validateStatus',this.validateStatus);
        }
        fileList.forEach((file) => {
          formData.append('files[]', file);
        });
        this.uploading = true
       
        postAction(this.uploadAction, formData).then((res) => {
          this.uploading = false
          if(res.status){
            if(res.code == 201){
             // this.errorTip(res.message, res.result)
             this.isShowErrorData=true;
             this.errorMsg=res.message;
             this.dataSource=res.data;
            }
            else{
              this.$message.success(res.message)
                 this.visible=false
           this.$emit('ok')
            }
           // this.visible=false
          //  this.$emit('ok')
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      // 是否开启校验 开关改变事件
      handleChangeValidateStatus(checked){
        this.validateStatus = checked==true?1:0
      },
      ExportTemplateXls(){
        let url =window._CONFIG['chooseSeatDomainURL']+ "/ActivityInfo/DownLoadSeatTemplate?sysactivityid="+this.operation.sysactivityid+"&sysvenueid="+this.operation.sysvenueid
        downloadFile(url,'SeatInfoExcelTemplate.xlsx');
      },


      handleExportErrData(){
        let mapObj = {
        personid: this.language['cs.person.personid'],
        pname: this.language['cs.person.pname'],
        sex: this.language['cs.person.sex'],
        jobname: this.language['cs.person.jobname'],
        deptname: this.language['cs.person.deptname'],
        phone:this.language['cs.person.phone'],
        email:this.language['cs.person.email'],
        workno:this.language['cs.person.workno'],
        seatno:"座位編號",
        errormsg:"错误信息",
      }
      exportFileExcel(this.dataSource, mapObj, "personInfoErrData")
      },


      // 错误信息提示
      errorTip(tipMessage, fileUrl) {
        const h = this.$createElement;
        let href = window._CONFIG['domianURL'] + fileUrl
        this.$warning({
          title: this.language['common.importSuccessButErrorData'],//,'导入成功,但是有错误数据!',
          content: h('div', {}, [
            h('div', tipMessage),
            h('span', this.language['common.implicitInfo']),//, '具体详情请 '),
            h('a', {
              attrs: {
                href: href,
                target: '_blank'
              },
            }, this.language['common.clickDownload']),//, '点击下载'),
          ]),
          onOk() {},
        });
      },

    }
  }
</script>

<style scoped>

</style>